import { createLazyDialog } from '@core/modal'

import type { TPromoReleaseWarningDialogProps } from './PromoReleaseWarningDialog.types'

export const AsyncPromoReleaseWarningDialog = createLazyDialog<
    TPromoReleaseWarningDialogProps,
    'PromoReleaseWarningDialog'
>(
    () =>
        import(
            /* webpackChunkName: 'dialog-promo-release-warning' */ './PromoReleaseWarningDialog'
        ),
    'PromoReleaseWarningDialog',
)
